import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';

class articleGif extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
        getImgCurrentIndex: PropTypes.func,
        photoActiveImageIndex: PropTypes.number,
        imageIndex: PropTypes.number,
    };

    state = {
        iswifi: false,
        isShowGifImg: false,
    };

    componentDidMount() {
        const connection =
            window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection;

        this.getNetwork();
        connection.addEventListener('typechange', this.getNetwork);
    }
    componentDidUpdate() {
        if (this.props.photoActiveImageIndex === this.props.imageIndex) {
            this.setState({
                iswifi: true,
                isShowGifImg: true,
            });
        }
    }

    getNetwork = () => {
        let network_state = '';
        const ua = window.navigator.userAgent;
        const connection =
            window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection;

        if (/NetType/.test(ua)) {
            const type = ua.match(/NetType\/(\S*)/);

            network_state = type[1];
        } else if (connection) {
            const network = connection.type;

            network_state = network;
        }

        if (String(network_state).toLocaleLowerCase() === 'wifi' || network_state === '5') {
            this.setState({
                iswifi: true,
                isShowGifImg: true,
            });
        } else {
            this.setState({
                iswifi: false,
                isShowGifImg: false,
            });
        }
    };

    gifImgPlayHandle = () => {
        const { content, getImgCurrentIndex } = this.props;
        const { isShowGifImg } = this.state;

        if (!isShowGifImg) {
            this.setState({
                isShowGifImg: true,
            });
        } else {
            getImgCurrentIndex(content.src);
        }
    };

    /**
     * 渲染网页布局
     */
    render() {
        const { content, getImgCurrentIndex } = this.props;
        const { isShowGifImg } = this.state;
        const loadlazyImag = 'https://x0.ifengimg.com/cmpp/2020/0602/83ea75648508d97size0_w16_h9.jpg';
        const gifStr = isShowGifImg ? content.src : content.staticSrc;

        return (
            <Fragment>
                <p className={styles.gifbox}>
                    <LazyImg
                        onClick={() => {
                            getImgCurrentIndex(content.src);
                        }}
                        placeholder={loadlazyImag}
                        data-gifsrc={content.src}
                        className="swiperImg"
                        src={gifStr}
                    />
                    {!isShowGifImg && (
                        <span
                            className={styles.gifMask}
                            onClick={() => {
                                this.gifImgPlayHandle();
                            }}
                        />
                    )}
                    {!isShowGifImg && (
                        <span className={styles.gifmarkbox}>
                            <span className={styles.gifmark}>点击播放 GIF</span>
                        </span>
                    )}
                </p>
            </Fragment>
        );
    }
}

export default errorBoundary(articleGif);
